export default __webpack_public_path__ + "static/media/Rectangle.d19535e6.svg";